module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/hiking_b2f44f.jpg";